import React, { Component } from 'react';
import { Col, Nav, NavItem, NavLink, Popover, PopoverBody } from 'reactstrap';

class PaymentMode extends Component {
    constructor(props) {
        super(props)
        this.state = {
            upi: false,
            debit_atm_otp: false,
            bharat_pin: false
        }
        // console.log("PAYMENT LIST ++++++",props.paymentList)
    }
 
    onHover = (type) => {
        if(type==="upi"){
            this.setState({
                upi: true
            });
        }else if(type === "debit-pin") {
            this.setState({
                debit_atm_otp: true
            });
        } else if ( type === "bharat-pin") {
            this.setState({
                bharat_pin: true
            });
        }
        else if ( type === "paylater") {
            this.setState({
                paylater: true
            });
        }
    }
    
    onHoverLeave = (type) => {
        if(type==="upi"){
            this.setState({
                upi: !this.state.upi
            });
        }else if(type === "debit-pin") {
            this.setState({
                debit_atm_otp: !this.state.debit_atm_otp
            });
        } else if ( type === "bharat-pin") {
            this.setState({
                bharat_pin: !this.state.bharat_pin
            });
        } else if ( type === "paylater") {
            this.setState({
                paylater: false
            });
        }
    }

    render() {
        const { t,disableAllPaymentView } = this.props;
        if(this.props.paymentList===undefined){
            return <div>No Payment option found</div>
        }
        return(
            <Col className="mob-pad0" xs="12">
                <div className="pay-mode-panel">
                    {/* { 
                        this.props.siEnabled &&
                        <p className="static-info">*This product is applicable for an automated recurring payment service. We only accept MasterCard and Visa Credit and Debit cards issued by ICICI Bank, Kotak Mahindra Bank, Citi Bank and Canara Bank.</p>
                    } */}
                    <Nav className= {"d-none d-lg-block "+ (disableAllPaymentView ? 'inactive': 'active' )}>
                        {this.props.paymentList.map((paymentType, i) => {
                            return (
                                <NavItem key={i} className={paymentType===this.props.selectedPayment ? 'active' : 'inactive'}>
                                    <NavLink href="#" onClick={() => this.props.changePayment(paymentType)}>
                                        {t(paymentType)}
                                        { paymentType==='UPI' && 
                                            <>
                                                <span onMouseEnter={() => this.onHover("upi")} onMouseLeave={() => this.onHoverLeave("upi")} className="float-right icon-info" id="Popover-1"></span>
                                                <Popover placement="right" isOpen={this.state.upi}  target={'Popover-1'}>
                                                    <PopoverBody><p className="text-13">UPI payment can be done using your Bank App, Google Pay, PhonePe, Paytm, WhatsApp or any BHIM UPI App</p></PopoverBody>
                                                </Popover>
                                            </>
                                        }
                                        { paymentType==='IDEBIT' && 
                                            <>
                                                <span  
                                                onMouseEnter={() => this.onHover("debit-pin")}
                                                 onMouseLeave={() => this.onHoverLeave("debit-pin")} 
                                                 className="float-right icon-info" 
                                                 id="Popover-2"></span>
                                                <Popover placement="right" isOpen={this.state.debit_atm_otp} target={'Popover-2'}>
                                                    <PopoverBody><p className="text-13">Make payment via your ATM card. <br/>Note: You will be redirected to your bank’s page to enter the ATM PIN / OTP</p></PopoverBody>
                                                </Popover>
                                            </>
                                        }
                                        { paymentType==='BHARATQR' && 
                                            <>
                                                <span onMouseEnter={() => this.onHover("bharat-pin")} onMouseLeave={() => this.onHoverLeave("bharat-pin")} className="float-right icon-info" id="Popover-3"></span>
                                                <Popover placement="right"  isOpen={this.state.bharat_pin} target={'Popover-3'}>
                                                    <PopoverBody><p className="text-13">Bharat QR payment can be done using your Bank App, Google Pay, PhonePe, Paytm, WhatsApp or any BHIM UPI App</p></PopoverBody>
                                                </Popover>
                                            </>
                                        }
                                        { paymentType==='ICICIPAYLATER' && 
                                            <>
                                                <span onMouseEnter={() => this.onHover("paylater")} onMouseLeave={() => this.onHoverLeave("paylater")} className="float-right icon-info" id="Popover-4"></span>
                                                <Popover placement="right"  isOpen={this.state.paylater} target={'Popover-4'}>
                                                    <PopoverBody><p className="text-13">{t("paylaterInfo")}</p></PopoverBody>
                                                </Popover>
                                            </>
                                        }
                                    </NavLink>
                                </NavItem>  
                            )
                        })}
                    </Nav>
                </div>
            </Col>
        );
    }
}

export default PaymentMode;